import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiAlert = {
  styleOverrides: { message: { fontWeight: 500 } },
} satisfies Components<Theme>['MuiAlert'];
